import { handleSearchParams } from "src/utils"
import { APICall } from ".."
import { REQUESTS_TABS } from "src/containers/Request"
import fileDownload from "js-file-download"

const ControllerName = "MobRequests"

export const GetRequests = (searchParams: any, tableFiller: any, hospitalId: number | null, tabType: number = REQUESTS_TABS.All) => {

    const searchData = handleSearchParams(searchParams, tableFiller)
    return APICall("get", `${ControllerName}${searchData}${hospitalId ? `&hospitalId=${hospitalId}` : ""}${tabType ? `&requestsTab=${tabType}` : ""}`)
}

export const GetRequestMedicines = (id: number, hospitalId: number, pharmId: number) => {
    return APICall("get", ControllerName + `/GetRequestMedicines/${id}?hospitalId=${hospitalId}&pharmacyId=${pharmId || ""}`)
}

export const GetAttachRequestEligibility = (id: number) => {
    return APICall("get", ControllerName + `/GetAttachRequestEligibility/${id}`)
}


export const SubmitRequest = (data: any) => {
    return APICall("post", ControllerName + `/SubmitRequest`, data)
}

export const ReturnMedicine = (id: string, note: string) => {
    return APICall("post", ControllerName + `/ReturnMedicines/${id}?returnReason=${note}`)
}

export const AddRequestAttachment = (data: any) => {
    return APICall("patch", ControllerName + "/AddRequestAttachments", data)
}

export const GetRequestsExcel = (searchParams: any, hospitalId: string | null, tabType: number = REQUESTS_TABS.All) => {
    let searchData = handleSearchParams(searchParams, {})
    let requestURL = `${ControllerName}/excel${searchData}${hospitalId ? `&hospitalId=${hospitalId}` : ""}${tabType ? `&requestsTab=${tabType}` : ""}`
    return APICall("get", requestURL).then((result: any) => {
        return new Promise((resolve) => {
            fileDownload(result.data, 'Requests.xlsx')
            resolve(result.data)
        })
    })

}
